import React from 'react'
import createUsePollingWithCache from 'hooks/createUsePollingWithCache'
import { getData as apiGetData } from 'api/Api'

type CardNamesData = {
  HomeLayouts: {
    Id: number
    Name: string
  }[]
}

const usePollingWithCache = createUsePollingWithCache<string | null>({
  getData: (ids, setData) => {
    apiGetData('HomeLayoutNames', { ids }).then((data: CardNamesData) => {
      ids.forEach(id => setData(id, (data.HomeLayouts.find(Card => Card.Id === Number(id)) || { Name: null }).Name))  
    })
  }
})

type RenderData = {
  name: string | null | undefined
  error?: any
  isLoading: boolean
}

type Props = {
  children?: (data: RenderData) => React.ReactNode

  id: number
}

const DeskName: React.FC<Props> = ({
  children,

  id,
}) => {
  const name = usePollingWithCache(String(id))

  if (children) return children({
    name,
    isLoading: false,
  })

  return name as any
}

export default DeskName
